import { Component, OnInit, inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../users/users.service';
import { TimeLinesService } from './timelines.service';
import { MenuItem, MessageService } from 'primeng/api';
import { encodeToBase64, decodeBase64ToText, dateFormat_YYYY_mm_dd } from "./../../utility"
import { GroupService } from '../groups/group.service';
import { DateFormatPipe } from '../../shared/pipes/dateFormat.pipe';
import { HelperService } from '../../shared/services/helper.service';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../shared/services/toast.service';

interface DayType {
  name: string,
  value: string
}

interface MonthType {
  name: string,
  value: string,
  quarter: string
}

interface Group {
  group_id: number;
  name: string;
  type: string;
  link: string;
  status: string;
}


@Component({
  selector: 'app-timelines',
  templateUrl: './timelines.component.html',
  styleUrl: './timelines.component.css',
  preserveWhitespaces:true,
  providers: [DateFormatPipe]
})
export class TimelinesComponent implements OnInit {
  toastService=inject(ToastService)
  timeLines!: any;
  totalRecords!: number;
  loading = false;
  visible: boolean = false;
  intialFormData={};
  currentDate:any;
  timeLineUrl=`${environment.opbBackendHost}/api/admin/timeline/list`; 
  months: MonthType[]=[
    { name: 'January', value: '01', quarter: 'Q1' },
    { name: 'February', value: '02', quarter: 'Q1' },
    { name: 'March', value: '03', quarter: 'Q1' },
    { name: 'April', value: '04', quarter: 'Q2' },
    { name: 'May', value: '05', quarter: 'Q2' },
    { name: 'June', value: '06', quarter: 'Q2' },
    { name: 'July', value: '07', quarter: 'Q3' },
    { name: 'August', value: '08', quarter: 'Q3' },
    { name: 'September', value: '09', quarter: 'Q3' },
    { name: 'October', value: '10', quarter: 'Q4' },
    { name: 'November', value: '11', quarter: 'Q4' },
    { name: 'December', value: '12', quarter: 'Q4' }
  ];
  dayType: DayType[]=[{ name: 'a business day', value: "business" }, { name: 'exact day',  value: "exact" }];
  
  // selectedMonths!: Month[];
  // selectedDayType!: DayType[];

  groupListItem: Group[] = [{
    "group_id": -1, 
    "name": "All", 
    "type": "chapter",
    "link": "standalone",
    "status": "1"
  }];

  timelineForm: FormGroup;
  dateRangeForm: FormGroup;

  private messageService = inject(MessageService);
  private fb = inject(FormBuilder);
  private timeLinesService=inject(TimeLinesService);
  private groupService = inject(GroupService);
  helper = inject(HelperService);
  timeLineListPayload: any;
  futureIteration: any=[];
  futureIterationTotalRecords: any;

  constructor(private dateFormatPipe: DateFormatPipe) {}

  ngOnInit(): void {
   
    this.timelineForm = this.fb.group({
      plan_start_day: [''],
      plan_start_months: [[]],
      plan_start_month: [[]],
      plan_start_day_type: [''],
      implementation_start_delay: [''],
      implementation_start_day_type: [''],
      implementation_end_delay: [''],
      review_start_delay: [''],
      review_start_day_type: [''],
      review_end_delay: ['']
    });

    this.dateRangeForm = this.fb.group({
      dateRanges: this.fb.array([]),
      timeline_id: [''],
    });
    
    this.groupList();

    this.timeLinesDetails();

    this.timeLinesList(0);

    const today = new Date();
    this.currentDate = today.toLocaleDateString('en-CA'); // 'en-CA' gives YYYY-MM-DD format
  }

  onDataLoaded(data:any){
    this.timeLines=data
  }
  filteredMonths: any[] = [...this.months];
  selectedMonths: any[] = []
  filterDropdownOptions() {
    const selectedValues = this.timelineForm.get('plan_start_months')?.value || [];
    this.filteredMonths = this.months.filter(month => selectedValues.includes(month.value));
    if(!selectedValues.includes(this.timelineForm.get('plan_start_month')?.value))
    this.timelineForm.get('plan_start_month')?.setValue('')
  }
  restoreSelection(): void {
    const selectedValues = this.timelineForm.get('plan_start_months')?.value || [];
    this.selectedMonths = selectedValues.map((value:any) => this.months?.find(m => m?.value === value)).filter((m:any) => m);
    this.filteredMonths = [...this.selectedMonths];
  }

  get dateRanges(): FormArray {
    return this.dateRangeForm.get('dateRanges') as FormArray;
  }
  addDateRange(initialValues: any = {}) {

    const dateRangeGroup = this.fb.group({
      group_id: [initialValues.group_id || -1],
      implement_start: [initialValues.implement_start || '', Validators.required],
      implement_end: [initialValues.implement_end || '', Validators.required],
      plan_start: [initialValues.plan_start || '', Validators.required],
      plan_end: [initialValues.plan_end || '', Validators.required],
      review_start: [initialValues.review_start || '', Validators.required],
      review_end: [initialValues.review_end || '', Validators.required],
    });
    this.dateRanges.push(dateRangeGroup);
  }

  removeDateRange(index: number) {
    this.dateRanges.removeAt(index);
  }


  resetDateRanges() {
    this.dateRanges.clear(); 
    this.addDateRange(this.intialFormData);
  }
  timeLinesDetails() {
    this.timeLinesService.getTimeLinesDetails({}).subscribe(
      (data: any) => {
        try {
          const parsedData = data.data;
          if(parsedData.error){
            this.messageService.add({ severity: 'warn', summary: 'Warn', detail: parsedData.message });
          } else {
          this.timelineForm.patchValue({
            plan_start_day: parsedData['plan_start_day'],
            plan_start_months: parsedData['plan_start_months'].split(",").map((num: any) => num.padStart(2, '0')),
            plan_start_month: parsedData['plan_start_month'].toString().padStart(2, '0'),
            plan_start_day_type: parsedData['plan_start_day_type'],
            implementation_start_delay: parsedData['implementation_start_delay'],
            implementation_start_day_type: parsedData['implementation_start_day_type'],
            implementation_end_delay: parsedData['implementation_end_delay'],
            review_start_delay: parsedData['review_start_delay'],
            review_start_day_type: parsedData['review_start_day_type'],
            review_end_delay: parsedData['review_end_delay']
          })
          this.restoreSelection();
        }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      })
  }

  onSubmit() {
    const data = {...this.timelineForm.value, plan_start_months: this.timelineForm.get('plan_start_months')?.value?.join(','), plan_start_month: Array.isArray(this.timelineForm?.get('plan_start_month')?.value) ? this.timelineForm?.get('plan_start_month')?.value?.join(','):this.timelineForm?.get('plan_start_month')?.value};
    
    const timeLinePayload = {...data};

    this.timeLinesService.saveTimeLines(timeLinePayload).subscribe(
      (data: any) => {
        
          try {
            const parsedData = data;
            if(parsedData.error){
              this.messageService.add({ severity: 'warn', summary: 'Warn', detail: parsedData.message });
            } else {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: parsedData.message });
              this.timeLinesDetails();
            }
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }


 timeLinesList(pageNo: number){
    this.loading = true;
    this.timeLineListPayload = {start:pageNo.toString()};
    this.timeLinesService.getTimeLines(this.timeLineListPayload).subscribe(
      (data: any) => {
          try {
            const parsedData = data;
            this.timeLines = parsedData.data || []; 
            this.totalRecords = parsedData.count;
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
          this.loading = false;
      },
      (error) => {
        console.error('Error fetching users', error);
        this.loading = false;
      }
    );
  }

  onFutureIteration(){
    this.timeLinesService.futureIterationTimeLines({"start":"0"}).subscribe(
      (data: any) => {
          try {
            const parsedData = data;
            this.timeLinesList(0)
            parsedData?.error
            ? this.toastService.error(parsedData?.message)
            : this.toastService.success(parsedData?.message || 'Timeline config detail fetched');
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  loadData(event: any) {
   
    const page = event.first / event.rows;
    this.timeLinesList(page);
  }

  selectTimelineData(selectedData: any) {
    
    this.dateRanges.clear();
    this.visible = true;
    // this.user = selectedUser; 

    this.intialFormData = {
      group_id: -1,
      implement_start: this.dateFormatPipe.transform(selectedData['implement_start']),
      implement_end: this.dateFormatPipe.transform(selectedData['implement_end']),
      plan_start: this.dateFormatPipe.transform(selectedData['plan_start']),
      plan_end: this.dateFormatPipe.transform(selectedData['plan_end']),
      review_start: this.dateFormatPipe.transform(selectedData['review_start']),
      review_end: this.dateFormatPipe.transform(selectedData['review_end']),
    };
   this.addDateRange(this.intialFormData);
   this.dateRangeForm.patchValue({
      timeline_id: selectedData['timeline_id']
    });
  }
  

  groupList(){
    const groupPayload = {type:"all",link:"all"};

    this.groupService.getGroup(groupPayload).subscribe(
      (data: any) => {
          try {
            const parsedData = data;
            this.groupListItem =[...this.groupListItem, ...parsedData['data']['chapter']['standalone'], ...parsedData['data']['cluster']['standalone'],...parsedData['data']['function']['standalone'],...parsedData['data']['function']['parent'],...parsedData['data']['function']['child']];
            //[...parsedData.data.function.standalone,...parsedData.data.function.parent,...parsedData.data.function.child]
           
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
      },
      (error) => {
        console.error('Error fetching groups', error);
      }
    );
  }

  updateDateRangeForm(){
    const dateRangesData = this.dateRangeForm.value.dateRanges;

    if(dateRangesData.length>0){
    // const payloadDate = {
    //   implement_start: dateFormat_YYYY_mm_dd(this.dateRangeForm.value.dateRanges[0]['implement_start']),
    //   implement_end: dateFormat_YYYY_mm_dd(this.dateRangeForm.value.dateRanges[0]['implement_end']),
    //   plan_start: dateFormat_YYYY_mm_dd(this.dateRangeForm.value.dateRanges[0]['plan_start']),
    //   plan_end: dateFormat_YYYY_mm_dd(this.dateRangeForm.value.dateRanges[0]['plan_end']),
    //   review_start: dateFormat_YYYY_mm_dd(this.dateRangeForm.value.dateRanges[0]['review_start']),
    //   review_end: dateFormat_YYYY_mm_dd(this.dateRangeForm.value.dateRanges[0]['review_end']),
    //   timeline_id: this.dateRangeForm.value['timeline_id'],
    // }
    const payload = dateRangesData.map((range:any) => {
      return {
        implement_start: dateFormat_YYYY_mm_dd(range['implement_start']),
        implement_end: dateFormat_YYYY_mm_dd(range['implement_end']),
        plan_start: dateFormat_YYYY_mm_dd(range['plan_start']),
        plan_end: dateFormat_YYYY_mm_dd(range['plan_end']),
        review_start: dateFormat_YYYY_mm_dd(range['review_start']),
        review_end: dateFormat_YYYY_mm_dd(range['review_end']),
        timeline_id: this.dateRangeForm.value['timeline_id']
      };
    });
    //const timeLineUpdatePayload = {payload:encodeToBase64(JSON.stringify(payloadDate))};
    payload.forEach((data:any) => { 
        this.timeLinesService.updateTimeLines(data).subscribe(
          (data: any) => {
            const decodedData = data;
              try {
                // const parsedData = JSON.parse(decodedData);
                // this.timeLines = parsedData.data || []; 
                // this.totalRecords = parsedData.count;
                
                if(decodedData.error){
                  this.messageService.add({ severity: 'warn', summary: 'Warn', detail: decodedData.message });
                } else {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: decodedData.message });
                  this.timeLinesList(0);
                  this.visible = false;
                }

              } catch (error) {
                console.error('Error parsing decoded data:', error);
              }
          },
          (error) => {
            console.error('Error fetching users', error);
          // this.loading = false;
          }
        );
    });
   }
  }

  closeModal(): void{
    this.visible = false;
    this.dateRanges.clear(); 
  }
}
